export const readIOSVersion = () => {
  /* Mozilla/5.0 (iPhone; CPU iPhone OS 16_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.1 Mobile/15E148 Safari/604.1 */
  //
  //  :step 1:
  //  Verify that we can read the user agent from navigator.
  if (!window) { return null }
  if (!window.navigator) { return null }
  if (!window.navigator.userAgent) { return null }

  //
  //  :step 2:
  //  Read our the user agent.
  const ua = window.navigator.userAgent
  const uaLower = ua.toLowerCase()

  //
  //  :step 3:
  //  Verify that we have an apple device.
  let iDeviceCounter = 0
  if (uaLower.includes("ipad")) { iDeviceCounter += 1 }
  if (uaLower.includes("iphone")) { iDeviceCounter += 1 }
  if (uaLower.includes("macintosh")) { iDeviceCounter += 1 }
  if (iDeviceCounter === 0) { return null }

  //
  //  :step 4:
  //  Now we can regex the ios version from the user agent.
  const iosVersion = ua.match(/ OS (\w+)/)[1]

  //
  //  :step 5:
  //  Now return the version number to the caller.
  const info = {
    text: `iOS ${iosVersion.replace("_", ".")}`,
    major: iosVersion.split("_")[0],
    minor: iosVersion.split("_")[1] || 0,
  }
  //
  //  Handle casting the values.
  if (info.major) {
    info.major = parseInt(info.major)
  }
  if (info.minor) {
    info.minor = parseInt(info.minor)
  }

  //
  //  :step 6:
  //  All done, return the info to the caller.
  return info
}

export const isIOSSixteenOrGreater = () => {
  try{
    const v = readIOSVersion()
    return v.major >= 16
  }catch(err){
    return false
  }
}